<template>
  <div class="flex-col gap-y-md">
    <dd-header-card header="Maak een selectie">
      <div class="flex-col gap-y-md">
        <dd-select
            title="Voor welke selectie wil je een campagne aanmaken?"
            v-model="search_id"
            rules="required"
            :searchable="true"
            name="selectie"
            option-filter-prop="children"
            :filter-option="filterOption"
            @input="handleSearchChange"
        >
          <a-select-opt-group v-for="(searches, model) in searchesGroupedByType"
                              v-bind:label="getTypeDescriptionByModel(model)"
                              v-bind:key="model">
            <a-select-option
                v-for="search in searches"
                :value="search.hash_id.toString()"
                :key="search.hash_id.toString()">
              {{ search.name }}
            </a-select-option>
          </a-select-opt-group>
        </dd-select>
        <dd-select
            title="Selecteer optioneel sub-selecties"
            v-model="dynamic_extending_search_ids"
            :searchable="true"
            mode="multiple"
            name="sub-selecties"
            option-filter-prop="children"
            :filter-option="filterOption"
        >
          <a-select-option v-for="dynamicExtendingSearch in dynamicExtendingSearches"
                           v-bind:value="dynamicExtendingSearch.id"
                           v-bind:key="dynamicExtendingSearch.id">
            {{ dynamicExtendingSearch.name }}
          </a-select-option>
        </dd-select>
      </div>
    </dd-header-card>
    <selection-preview-component
        v-if="search_id"
        :search="selectedCreatingSearch"
        :search-id="search_id"
        :dynamic-extending-search-ids="dynamic_extending_search_ids"
    >
    </selection-preview-component>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {MainSearchableClassesEnum} from '../enums'
import {mapFields} from 'vuex-map-fields'
import SelectionPreviewComponent from './SelectionPreviewComponent.vue'

export default {
  name: "GeneralSelectionComponent",
  components: {
    SelectionPreviewComponent,
  },
  data () {
    return {
      loaded: false,
      loading: false,
      processType: null,
      extendingSearchesLoadedForModel: null,
    }
  },
  mounted () {
    const STORE_KEY = '$_automation'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    this.sendEmail = true

    this.fetchSearches()
      .finally(() => {
        this.handleSearchChange()
        this.loaded = true
      })
  },
  computed: {
    ...mapGetters('$_automation', [
      'automationActions',
      'searches',
      'searchesGroupedByType',
      'extendingSearches',
      'dynamicExtendingSearches',
      'selectedCreatingAutomationAction',
      'selectedCreatingSearch',
      'selectedExtendingSearches',
      'selectedDynamicExtendingSearches',
    ]),
    ...mapFields('$_automation', [
      'creatingAutomation.automation_action_id',
      'creatingAutomation.search_id',
      'creatingAutomation.dynamic_extending_search_ids',
      'selectedExtendingSearchesIds',
      'creatingAutomation',
      'creatingAutomation.run_interval',
      'creatingAutomation.is_recurring',
      'creatingAutomation.needs_verification',
      'creatingAutomation.title',
      'creatingAutomation.description',
      'creatingAutomation.create_signal',
      'creatingAutomation.create_task',
      'creatingAutomation.send_email',
    ]),
    selectedSearchDescription () {
      return this.selectedSearchName + ' ' + this.selectedExtendingSearchesDescription
    },
    selectedSearchName () {
      if (this.selectedCreatingSearch !== undefined) {
        return this.selectedCreatingSearch.name
      }

      return 'onbekend'
    },
    currentSearchModel () {
      if (this.selectedCreatingSearch !== undefined) {
        return this.selectedCreatingSearch.model
      }

      return 'onbekend'
    },
    selectedExtendingSearchesDescription () {
      if (this.selectedExtendingSearches.length > 0) {
        return this.selectedExtendingSearches.map((extendingSearch) => {
          return extendingSearch.name
        })
          .join(', ')
      }

      return ''
    },
    selectionStep () {
      return this.activeStep === 'selection'
    },
    settingsStep () {
      return this.activeStep === 'settings'
    },
    verifyStep () {
      return this.activeStep === 'verify'
    },
    isNextEnabled () {
      return true
    },
  },
  methods: {
    ...mapActions('$_automation', [
      'fetchAutomationActions',
      'fetchSearches',
      'fetchSearchesByAutomationAction',
      'fetchExtendingSearchesByModel',
      'fetchDynamicExtendingSearchesByModel',
      'fetchDynamicExtendingSearchesForSearch',
      'clearExtendingSearches',
      'clearDynamicExtendingSearches'
    ]),
    getTypeDescriptionByModel (model) {
      if (model === MainSearchableClassesEnum.CUSTOMER) { return 'Klanten' }
      if (model === MainSearchableClassesEnum.POLICY) { return 'Polissen' }
      if (model === MainSearchableClassesEnum.DAMAGE) { return 'Schades' }
      if (model === MainSearchableClassesEnum.MORTGAGE) { return 'Hypotheken' }
      if (model === MainSearchableClassesEnum.MORTGAGE_PART) { return 'Leningdelen' }
      if (model === MainSearchableClassesEnum.OBLIGATION) { return 'Kredieten' }
      if (model === MainSearchableClassesEnum.TASK) { return 'Taken' }
      return null
    },
    handleAutomationActionChange () {
      this.fetchSearchesByModel(this.selectedCreatingAutomationAction.model)
      this.clearExtendingSearches()
      this.clearDynamicExtendingSearches()
    },
    handleSearchChange () {
      if (
          this.extendingSearchesLoadedForModel !== this.currentSearchModel
          && this.currentSearchModel !== 'onbekend'
      ) {
        this.extendingSearchesLoadedForModel = this.currentSearchModel
        this.dynamic_extending_search_ids = []
        this.clearExtendingSearches()
        this.clearDynamicExtendingSearches()
      }

      this.fetchDynamicExtendingSearchesForSearch(this.search_id)
    },
    filterOption (input, option) {
      const children = option.componentOptions.children;

      if (typeof option.componentOptions.propsData.label !== 'undefined') {
          return children.includes((child) =>
            child.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0)
        }

      return children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  },
}
</script>

<style scoped>

</style>
